import { memo } from "react";

import { Grid } from "@mui/material";

import { DateTime } from "luxon";

import LitcoLogo from "../../../../../images/LitcoLogo";

export default memo(function InquirySubHeader(props) {
  const { lawArea, meetingDateTime } = props;

  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <table>
          <tbody>
            <tr>
              <td>Law:&emsp;</td>
              <td>{lawArea}</td>
            </tr>

            <tr>
              <td>Date and Time:&emsp;</td>
              <td>{DateTime.fromISO(meetingDateTime).toLocaleString(DateTime.DATETIME_MED)}</td>
            </tr>
          </tbody>
        </table>
      </Grid>

      <Grid item display={{ xs: "none", sm: "block" }}>
        <LitcoLogo opacity={0.4} size={30} />
      </Grid>
    </Grid>
  );
});
